import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * Pagina callback per nuova tab di impersonation.
 *
 * Riceve il token via query param (`?token=xxx`), lo salva in sessionStorage
 * (NON localStorage — scoped per tab, così la sessione superadmin nella tab
 * originale resta intatta), poi naviga a '/'.
 *
 * Pattern:
 *  Tab SuperAdmin → window.open('/impersonate-callback?token=...', '_blank')
 *  Nuova tab     → questa pagina → sessionStorage.token → reload to '/'
 */
const ImpersonateCallback = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    // Salva in sessionStorage (scoped a questa tab) per non sovrascrivere
    // il token superadmin nella tab originale.
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("is_impersonation_tab", "1");
    // Hard reload per attivare AuthProvider con il nuovo token
    window.location.replace("/");
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-violet-50 to-indigo-50">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-violet-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-sm text-gray-600">Accesso supporto in corso…</p>
      </div>
    </div>
  );
};

export default ImpersonateCallback;
